import OrganizationManagerList from './OrganizationManagerList';

export default OrganizationManagerList;
